import { useMemo } from 'react';

import { StoreItem, useShowConsumerStoreItem } from '@givebacks/api/store';

type UseCheckoutButtons = {
  quantity?: number;
  options?: StoreItem['options'];
  storeId: string;
  storeItemId: string;
};
const useCheckoutButtons = ({ quantity, storeId, storeItemId }: UseCheckoutButtons) => {
  const { data: storeItem, isLoading } = useShowConsumerStoreItem({
    uuid: storeItemId,
    causeId: storeId,
  });
  const hasOptions = useMemo(() => Boolean(storeItem && storeItem?.options?.length), [storeItem]);

  const hasMultiple = quantity && quantity > 1;

  return {
    hasOptions,
    hasMultiple,
    isLoading,
  };
};

export { useCheckoutButtons };
